import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import TopBar from '../../../app/components/TopBar/TopBar';
import { AiOutlineWarning } from 'react-icons/ai';
import { notificationActions } from '../../../app/redux/notification.slice';

import { NewAuth } from '../../../models/auth';
import { getNewAuthByToken } from '../../../services/api/userApi';
import SignUpUserForm from '../../user/forms/SignUpUserForm';

import './login.css';
import { Alert } from 'reactstrap';

interface ParamsProps {
  confirmationToken: string;
}

const SignUp: React.FC = () => {
  const { confirmationToken } = useParams<ParamsProps>();

  const [newAuth, setNewAuth] = useState<NewAuth>();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    setError('');
    if (confirmationToken) {
      getNewAuthByToken(confirmationToken).subscribe(
        (response) => {
          setNewAuth(response);
          setIsLoading(false);
        },
        (error: Error) => {
          setError('Error: Invalid Confirmation Token');
          setIsLoading(false);
          dispatch(
            notificationActions.setToast({
              severity: 'danger',
              message: error.message,
              title: 'Error: Invalid Confirmation Token',
            })
          );
        }
      );
    }
  }, []);

  return (
    <div>
      <div className="container container-width-set-none">
        <div className="row justify-content-center">
          <div className="col-sm-6 margin-top-set-5vh">
            <div className="row justify-content-md-center">
              <div className="col-sm-8">
                {isLoading ? (
                  <div>Loading...</div>
                ) : error ? (
                  <div className="p-5 margin-top-set-10vh text-align-center">
                    <AiOutlineWarning size={100} color="red" />
                    <h2 className="title-tag-style mt-3 font-color-red">
                      {error}
                    </h2>
                    <Alert color="danger">
                      There may happen when you enter your URL manually and
                      missed some words in the URL or some connection problems
                      with our servers. Please contact our 24*7 support team for
                      more information.
                    </Alert>
                  </div>
                ) : (
                  <div>{newAuth && <SignUpUserForm auth={newAuth} />}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
